module.exports = __webpack_public_path__ + "static/img/A54.783d7edc.jpg";